// extracted by mini-css-extract-plugin
export default {"button":"furusatoNosei_button__9AgX9","icon":"furusatoNosei_icon__CxRHm","notice":"furusatoNosei_notice__fVn5s","applied":"furusatoNosei_applied__BqP8H"};